// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration

// const firebaseConfig = {
//   apiKey: "AIzaSyASqq6SGKEt5bzioEbBK9tW9PsF1qan51A",
//   authDomain: "doxzonlivechat.firebaseapp.com",
//   projectId: "doxzonlivechat",
//   storageBucket: "doxzonlivechat.firebasestorage.app",
//   messagingSenderId: "117390204888",
//   appId: "1:117390204888:web:e2452ab9216aa349d35cad"
// };

// const firebaseConfig = {
//   apiKey: "AIzaSyC1NhT9e2V8CoxomQrzAefQP28s6kuHc70",
//   authDomain: "doxzon-86f72.firebaseapp.com",
//   projectId: "doxzon-86f72",
//   storageBucket: "doxzon-86f72.firebasestorage.app",
//   messagingSenderId: "5507771868",
//   appId: "1:5507771868:web:29832c5b7fc8a135a9f319"
// };

const firebaseConfig = {
  apiKey: "AIzaSyCLUYs-yYAfgB5DINyvOatEg2kisysam1w",
  authDomain: "doctele-edc27.firebaseapp.com",
  projectId: "doctele-edc27",
  storageBucket: "doctele-edc27.firebasestorage.app",
  messagingSenderId: "998978084367",
  appId: "1:998978084367:web:0db5c9e967493497338d7a"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

const db = getFirestore(app);

export { app, db };